import { Box, Img, Text } from '@chakra-ui/react'
import { SitePreview as SitePreviewType } from '@/types/feed'

type SitePreviewProps = {
  size?: 'sm' | 'md'
  sitePreview: SitePreviewType
}

export const SitePreview = ({ size = 'md', sitePreview }: SitePreviewProps) => {
  return (
    <Box
      as="span"
      w={'100%'}
      cursor={'pointer'}
      onClick={(e: any) => {
        e.preventDefault()
        window.open(sitePreview.url, '_blank')
      }}
      textDecor={'none'}
      style={{ textDecoration: 'none' }}
      role="group"
      _groupHover={{ bg: 'blackAlpha.50' }}
    >
      <Img
        border={'1px solid'}
        borderColor={'blackAlpha.100'}
        borderBottom={'none'}
        mt={3}
        w={'100%'}
        objectFit="cover"
        borderTopRadius={4}
        loading={'lazy'}
        src={sitePreview.image_url || '/'}
      />
      <Box
        py={4}
        px={5}
        h={'auto'}
        border={'1px solid'}
        borderColor={'blackAlpha.100'}
        borderTop={'none'}
        borderBottomRadius={4}
        alignItems="start"
        _groupHover={{ bg: 'blackAlpha.50' }}
      >
        <Text
          fontSize={size == 'md' ? 12 : 6}
          color={'gray.500'}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          {sitePreview.url}
        </Text>

        <Text
          mt={2}
          mb={1}
          fontSize={size == 'md' ? 14 : 7}
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
        >
          {sitePreview.title}
        </Text>

        <Text
          fontSize={size == 'md' ? 14 : 7}
          color={'gray.500'}
          noOfLines={size == 'md' ? 2 : 1}
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {sitePreview.description}
        </Text>
      </Box>
    </Box>
  )
}
